export default __webpack_public_path__ + "static/media/favouriteFilled.e9f06242.svg";